import React from 'react';
import style from './Body.css';

const MyCode = () => {
    return (
        <div className={style.bodyOuterDiv}>
            <div className={style.textBox}>
                <p>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                <br></br>
                <a href='https://github.com/caseywar'> https://github.com/caseywar </a>
                </p>
            </div>
        </div>
    )
}

export default MyCode;
